import type ContentStrapi from "~/libs/interfaces/ContentStrapi";
import type ContentLocal from "~/libs/interfaces/ContentLocal";

const contentLocalFactory = {
  createContentFromStrapi(content?: ContentStrapi): ContentLocal | undefined {
    if (!content) {
      return undefined;
    }
    // console.log('Contentt blocks', )
    return {
      id: content.id,
      documentId: content.documentId,

      createdAt: content.createdAt ? new Date(content.createdAt) : undefined,
      updatedAt: content.updatedAt ? new Date(content.updatedAt) : undefined,
      publishedAt: content.publishedAt ? new Date(content.publishedAt) : undefined,

      title: content.title,
      slug: content.slug,
      content: content.content,
    }
  }
}
export default contentLocalFactory